import React, { useContext } from 'react';
import _ from 'lodash';
import {
  CardBoldSmallValue,
  MeetingSeatRatioRow,
  SmallCard,
  SmallCardTitle,
} from 'spw-components/project-details-tabs/program-summary/esa-single-page-summary/styles';
import { Box, Grid } from '@mui/material';
import {
  CardSmallValue,
  CardValueTitle,
} from 'spw-programming-projects/program-summary/components/styles';
import { asRatio, numberWithCommasOrDash } from 'spw-shared/utils';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import { PaddedCardTitle } from 'spw-programming-projects/program-summary/single-page-summary/styles';
import { ProgramSummaryCardsContext } from 'spw-esa-projects/program-summary/summary-cards';
import CardIcon from 'spw-esa-projects/program-summary/card-icon';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';
import { useCardIcon } from 'spw-esa-projects/program-summary/cards/hooks';

const { isNaN, isFinite } = _;

export const MeetingSeatRatioCard = ({
  meetingSeats,
  workSeats,
  relation,
}: {
  meetingSeats: number;
  workSeats: number;
  relation: number;
}) => {
  const { showRsf, selectedCardIcon, onClickCardIcon } = useContext(
    ProgramSummaryCardsContext
  );
  const displayRelation =
    !isNaN(relation) && isFinite(relation)
      ? asRatio(relation, 2, true)
      : NO_DATA_TO_SHOW;

  const cardIcon = useCardIcon(ProgramSummaryCardType.meetingSeatRatio);

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCardIcon(event, cardIcon);
  };

  const isIconCardSelected =
    selectedCardIcon?.cardType === ProgramSummaryCardType.meetingSeatRatio;

  if (!cardIcon) return null;

  return (
    <SmallCard data-testid="esa_summary_meeting_seat_ratio" $tall={showRsf}>
      {showRsf ? (
        <PaddedCardTitle>Meeting Seat Ratio</PaddedCardTitle>
      ) : (
        <SmallCardTitle>Meeting Seat Ratio</SmallCardTitle>
      )}
      <Grid container>
        <Grid item xs={12}>
          <MeetingSeatRatioRow display="flex" $padded={showRsf}>
            <Box ml={0.5} mr={2.5}>
              <CardIcon
                iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                onClick={handleIconClick}
                height={36}
                isSelected={isIconCardSelected}
              />
            </Box>
            <Box>
              <CardBoldSmallValue>{displayRelation}</CardBoldSmallValue>
              <CardValueTitle>Meeting Seats to Work Seats</CardValueTitle>
            </Box>
          </MeetingSeatRatioRow>
          <CardValueTitle>
            <CardSmallValue data-testid="meeting_seats">
              {numberWithCommasOrDash(meetingSeats)}
            </CardSmallValue>{' '}
            Meeting Seats /<br />
            <CardSmallValue data-testid="work_seats">
              {numberWithCommasOrDash(workSeats)}
            </CardSmallValue>{' '}
            Work Seats
          </CardValueTitle>
        </Grid>
      </Grid>
    </SmallCard>
  );
};
